<template lang="pug">
div
    modal(v-show="isShowModal_",:titulo="nameModulo.toUpperCase() + ': ' + ItemSelect.Name" bindClass="col-md-7 col-sm-12" , @close="isShowModal_=false")
        div(slot='body')  
            .card-body.bg-light  
                .form-row
                    .col-md-2.col-sm-12(v-show="ItemSelect.BaseIdDocListSelect!=0 && this.ItemSelect.BaseIdDocListSelect!=undefined") 
                        label Dependencia  
                        select.form-control.form-control-sm(v-if="tableInfoDependencia", v-model="parameterInsert.BaseIdDocListSelectValue")
                            option(value=0, selected) 
                            option(v-for="(item,index) in tableInfoDependencia", :value="item.IdDocListSelectValue") {{item.Text}} 
                    .col-md-3.col-sm-12
                        label Texto   
                        input.form-control.form-control-sm(v-model="parameterInsert.Text" )
                    .col-md-3.col-sm-12
                        label Valor
                        input.form-control.form-control-sm(v-model="parameterInsert.Value" ) 
                    .col-md-2col-sm-12(v-show="ItemSelect.IsActiveEmail==1") 
                        label Se Envia Email Cuando
                        select.form-control.form-control-sm(v-model="parameterInsert.IsSendEmail")
                            option(value=1) Hay No Conformidades
                            option(value=3) Se Crea Documento
                            option(value=2) No Enviar Email 
                    .col-md-2.col-sm-12
                        label 
                        button.btn.bg-primary.text-light.btn-block(@click="Insert()") AGREGAR 
                            i.fa.fa-plus  
            .card-body.bg-light    
                .form-group
                        table.table.table-sm.table-borderedonlytable
                            thead.bg-table.text-white
                                th Editar
                                th Texto 
                                th Valor  
                                th(v-if="ItemSelect.BaseIdDocListSelect!=0") Depende de Valor 
                                th(v-if="ItemSelect.IsActiveEmail==1") Se Envia Email Cuando
                                th Estado                       
                            tbody.bg-white(name="table-fade", is="transition-group") 
                                tr(v-if="tableInfo.length", v-for="(item,index) in tableInfo", :key="index")
                                    td
                                        button.btn.btn-sm.btn-info(v-if="item.Update==0", @click="item.Update = 1")     
                                            i.fa.fa-edit  
                                        button.btn.btn-sm.btn-warning(v-else, @click="item.Update = 0; Update(item)")     
                                            i.fa.fa-floppy-o
                                    td
                                        div(v-if="item.Update == 0") {{item.Text}} 
                                        input.form-control.form-control-sm(v-else,v-model="item.Text", :readonly="item.Update==0 ? true:false") 
                                    td
                                        div(v-if="item.Update == 0") {{item.Value}} 
                                        input.form-control.form-control-sm(v-else,v-model="item.Value", :readonly="item.Update==0 ? true:false")  
                                    td(v-if="ItemSelect.BaseIdDocListSelect!=0") 
                                        | {{item.BaseText}}
                                    td(v-if="ItemSelect.IsActiveEmail==1") 
                                        div(v-if="item.Update == 0") 
                                            div(v-if="item.IsSendEmail==1")  Hay No Conformidades 
                                            div(v-else-if="item.IsSendEmail==3") Se Crea Documento
                                            div(v-else) No Enviar Email 
                                        select.form-control.form-control-sm(v-else, v-model="item.IsSendEmail" , :disabled="item.Update==0 ? true:false")
                                            option(value=1) Hay No Conformidades
                                            option(value=3) Se Crea Documento
                                            option(value=2) No Enviar Email 
                                    td  
                                        div(v-if="item.Update == 0") {{item.Active==1 ? 'Activo':'Inactivo'}}
                                        select.form-control.form-control-sm(v-else, v-model="item.Active" , :disabled="item.Update==0 ? true:false")
                                            option(value=1) Activa
                                            option(value=0) Inactiva                        
                  
</template>
<script>
import modal from "../../../../complementos/modal.vue" 
import model from "../../../../models/docListSelectValue.js" 
import apiWeb from "../../../../api/apiSLC.js"
export default {
    props:{  
        IsShowModal:Boolean ,
        ItemSelect:Object 
    },  
    data(){
        return{
            nameModulo:'Valores Listas Desplegables',
            pathApi:'DocListSelect/DocListSelectValue', 
            parameterUpdate:Object.assign({}, model.parameterUpdate),
            parameterInsert:Object.assign({}, model.parameterInsert),
            parameterView:Object.assign({}, model.parameterView), 
            tableInfo:[] ,
            tableInfoDependencia:[]
        }
    },
    components:{
        modal
    },
    computed:{
        isShowModal_ :{
                        get(){
                            this.List_Info() 
                            this.List_Info_Dependencia() 
                            return this.IsShowModal 
                        },
                        set(val){
                            this.List_Info() 
                            this.List_Info_Dependencia() 
                            this.$emit("update:IsShowModal",val)
                        }
        } 
    },
    mounted(){
       this.List_Info()
    },
    methods:{
        List_Info(){
            console.log("paso")
            this.parameterView.IdDocListSelect=this.ItemSelect.IdDocListSelect
          //  this.parameterView.IdEnterprise=this.$info.idEnterprise
            apiWeb.post(this.pathApi + "_View",this.parameterView)
                    .then(result=>{
                                if(result.status==0){
                                    this.tableInfo=JSON.parse(result.value) 
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        List_Info_Dependencia(){
            if(this.ItemSelect.BaseIdDocListSelect!=0 && this.ItemSelect.BaseIdDocListSelect!=undefined){
                 
                var parameterViewDependencia=Object.assign({}, model.parameterView)
                parameterViewDependencia.IdDocListSelect=this.ItemSelect.BaseIdDocListSelect
                parameterViewDependencia.IdEnterprise=this.$info.idEnterprise
                parameterViewDependencia.Active=1
                console.log(parameterViewDependencia)
                apiWeb.post(this.pathApi + "_View",parameterViewDependencia)
                        .then(result=>{
                                    if(result.status==0){
                                        this.tableInfoDependencia=JSON.parse(result.value) 
                                    }
                                    else{
                                        this.$msgbox.show(result.message,"Error nivel 1")
                                    }
                        })
                        .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
            }
        },
        Insert(){
            console.log(this.parameterInsert)
            if(this.validate(this.parameterInsert)){
                this.parameterInsert.IdDocListSelect=this.ItemSelect.IdDocListSelect
                this.parameterInsert.User=this.$info.email
                this.parameterInsert.IP=this.$info.ip
                apiWeb.post(this.pathApi +"_Insert",this.parameterInsert)
                        .then(result=>{ 
                                if(result.status==0){
                                    this.List_Info()
                                    this.parameterInsert=Object.assign({}, model.parameterInsert) 
                                    this.$msgbox.show("Ingresado","Notificacion")
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                    this.List_Info()
                                }

                        })
                        .catch(ex=>{
                                    this.$msgbox.show(ex.message,"Error nivel 2")
                                    this.List_Info()})
            }
            
        },
        Update(item){
            console.log(item)
            this.parameterUpdate.Text=item.Text
            this.parameterUpdate.Value=item.Value
            this.parameterUpdate.Active=item.Active
            this.parameterUpdate.IsSendEmail=item.IsSendEmail
            this.parameterUpdate.IdDocListSelectValue=item.IdDocListSelectValue
            if(this.validate(this.parameterUpdate)){
                this.parameterUpdate.IdDocListSelect=this.ItemSelect.IdDocListSelect
                this.parameterUpdate.User=this.$info.email
                this.parameterUpdate.IP=this.$info.ip
                apiWeb.post(this.pathApi + "_Update",this.parameterUpdate)
                        .then(result=>{ 
                                if(result.status==0){
                                    this.List_Info()
                                    this.IsShowModalUpdate=false
                                    this.$msgbox.show("Actualizado","Notificacion")
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                     this.List_Info()
                                }
                        })
                        .catch(ex=>{
                                    this.$msgbox.show(ex.message,"Error nivel 2")
                                    this.List_Info()})
            }
        },
        validate(parameter){ 
            if(parameter.Text=='' || parameter.Text==null ){
                this.$msgbox.show("Ingrese Texto","Alerta")
                return false
            }
            else if(parameter.Value=='' || parameter.Value==null ){
                this.$msgbox.show("Ingrese Valor","Alerta")
                return false
            } 
            else if(this.ItemSelect.BaseIdDocListSelect!=0 && this.ItemSelect.BaseIdDocListSelect!=undefined){
                if(parameter.BaseIdDocListSelectValue==0){
                    this.$msgbox.show("Selecione Dependencia","Alerta")
                    return false
                }
                else{
                    return true
                }            
            }                    
            else{
                return true
            }
        }
    }

    
}
</script>